import { flow } from 'fp-ts/function';
import { get } from 'lodash/fp';
import { createAsyncActionTypes, createAction } from '@mews/framework';
import { ApplicationState, SimpleUser } from '@mews-commander/types';
import { getFullName } from '@mews-commander/utils';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createEntitiesReducer, createBaseEntitySelectors } from './utils';

export const NAME = 'simpleUsers';

export const SIMPLE_USERS_FETCH = prefix('SIMPLE_USERS_FETCH');
export const [SIMPLE_USERS_FETCH_STARTED, SIMPLE_USERS_FETCH_SUCCEEDED, SIMPLE_USERS_FETCH_FAILED] =
    createAsyncActionTypes(SIMPLE_USERS_FETCH);

export const [getSimpleUsers, getSimpleUsersByIds, getSimpleUserByOwnerId, getSimpleUser] = createBaseEntitySelectors<
    ApplicationState,
    SimpleUser,
    typeof NAME
>(parentSelector, NAME);

export const getSimpleUserEmail = flow(getSimpleUser, get('email'));
export const getSimpleUserFullName = flow(getSimpleUser, getFullName);
export const getSimpleUserImageId = flow(getSimpleUser, get('imageId'));

export const setSimpleUsers = (entities: Array<SimpleUser>) => createAction(SIMPLE_USERS_FETCH_SUCCEEDED, { entities });

export const simpleUsersReducer = createEntitiesReducer({
    FETCH_SUCCESS: SIMPLE_USERS_FETCH_SUCCEEDED,
});
